import { use } from 'react';
import { DropdownContexts } from '../../../../context/DropdownContext';
import { ListWrapper } from '../../style';
import { GroupExpandedList } from './components/GroupExpandedList';

export const GroupedExpandableList = () => {
  const { items } = use(DropdownContexts.useItems);
  const { searchResults, searchActive } = use(DropdownContexts.useSearch);

  const itemsToRender = searchActive ? searchResults : items;

  return (
    <ListWrapper>
      {itemsToRender.map((item) => (
        <GroupExpandedList key={item.label + item.value} item={item} />
      ))}
    </ListWrapper>
  );
};
